import React from "react";
import { useApp } from "@/context/AppProvider";
import { EditableText } from "@/components/editable";

export const Marquee = () => {
  const { tr, editMode } = useApp();
  const text = tr.marquee;

  if (editMode) {
    return (
      <section data-testid="marquee" className="relative py-10 md:py-14 border-y" style={{ backgroundColor: "var(--bone)", borderColor: "rgba(19,19,19,0.08)" }}>
        <div className="container-lux">
          <EditableText as="p" path={["marquee"]} value={text} className="font-display text-3xl md:text-5xl" style={{ color: "var(--ink)" }} />
        </div>
      </section>
    );
  }

  return (
    <section data-testid="marquee" className="relative py-10 md:py-14 overflow-hidden border-y" style={{ backgroundColor: "var(--bone)", borderColor: "rgba(19,19,19,0.08)" }}>
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <span key={k} className="font-display text-5xl md:text-7xl lg:text-8xl pe-8" style={{ color: "var(--ink)" }}>
            {text.repeat(2)}
          </span>
        ))}
      </div>
    </section>
  );
};
